"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _redux = require("redux");

var _reduxObservable = require("redux-observable");

var _empty = require("rxjs/observable/empty");

var _immutable = require("immutable");

var SettingsModule =
/*#__PURE__*/
function () {
  function SettingsModule(_ref) {
    var route = _ref.route,
        shouldModuleRender = _ref.shouldModuleRender,
        routes = _ref.routes,
        rootEpic = _ref.rootEpic,
        reducer = _ref.reducer,
        modules = _ref.modules,
        dsn = _ref.dsn,
        newRelicAppId = _ref.newRelicAppId;
    (0, _classCallCheck2.default)(this, SettingsModule);

    if (typeof route !== 'string' && !(route instanceof String)) {
      throw new Error('Every module must define a string route');
    }

    this.route = route;

    if (modules) {
      if (!Array.isArray(modules)) {
        throw new Error('Nested modules must be contained in an array');
      }

      if (!modules.length) {
        throw new Error('Modules must be a non-zero sized array');
      }

      this.modules = modules.map(function (module) {
        if (!(module instanceof SettingsModule)) {
          return new SettingsModule(module);
        }

        return module;
      });

      if ((0, _immutable.Set)(this.modules.map(function (module) {
        return module.route;
      })).size !== this.modules.length) {
        throw new Error('Nested modules must have unique routes');
      }

      if (reducer) {
        throw new Error('Modules with child modules cannot have a reducer');
      }
    } else {
      if (!routes) {
        throw new Error('A module must specify routes');
      }

      if (!reducer || typeof reducer !== 'function') {
        throw new Error('A module with no nested modules must specify a root reducer');
      }
    }

    if (shouldModuleRender && typeof shouldModuleRender !== 'function') {
      throw new Error('shouldModuleRender must be provided as a function');
    }

    this._shouldModuleRender = shouldModuleRender || function () {
      return true;
    };

    this.routes = routes;
    this.modules = this.modules || null;
    this.reducer = this._createRootReducer(reducer);
    this.rootEpic = this._createRootEpic(rootEpic);
    this.dsn = dsn;
    this.newRelicAppId = newRelicAppId;
  }

  (0, _createClass2.default)(SettingsModule, [{
    key: "shouldModuleRender",
    value: function shouldModuleRender(_ref2) {
      var scopes = _ref2.scopes,
          gates = _ref2.gates;

      if (this.modules) {
        return this._shouldModuleRender({
          scopes: scopes,
          gates: gates
        }) && this.modules.some(function (module) {
          return module.shouldModuleRender({
            scopes: scopes,
            gates: gates
          });
        });
      }

      return this._shouldModuleRender({
        scopes: scopes,
        gates: gates
      });
    }
  }, {
    key: "_createRootReducer",
    value: function _createRootReducer(reducer) {
      if (this.modules) {
        return (0, _redux.combineReducers)((0, _extends2.default)({}, this.modules.reduce(function (acc, module) {
          return Object.assign({}, acc, (0, _defineProperty2.default)({}, module.route, module.reducer));
        }, {})));
      }

      return reducer;
    }
  }, {
    key: "_createRootEpic",
    value: function _createRootEpic() {
      var epic = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
        return (0, _empty.empty)();
      };

      if (this.modules) {
        return _reduxObservable.combineEpics.apply(void 0, (0, _toConsumableArray2.default)(this.modules.map(function (module) {
          return module.rootEpic;
        })));
      }

      return epic;
    }
  }, {
    key: "_createPath",
    value: function _createPath() {
      var _this = this;

      var parentPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.List)();
      this._path = parentPath.push(this.route);

      if (this.modules) {
        this.modules.forEach(function (module) {
          module._createPath(_this._path);
        });
      }
    }
  }]);
  return SettingsModule;
}();

exports.default = SettingsModule;
module.exports = exports.default;